import { MutableState } from 'src/replicant/State';
import * as Match2 from '..';
import { Match2DailyChallengeGoal } from './match2-dailychallenge.ruleset';
import {
  getDailyChallenge,
  getDailyChallengeDay,
  getDailyChallengeRewardGems,
  isDailyChallengeComplete,
} from './match2-dailychallenge.getters';
import { getMatch2Level } from '../match2.getters';
import { CurrencyReplicantAPI } from 'src/replicant/inventory/inventory.utils';

export function startDailyChallenge(state: MutableState, now: number): void {
  const day = getDailyChallengeDay(now);
  state.match2.dailyChallenge = {
    day,
    timestamp: now,
    startingLevel: getMatch2Level(state),
    progress: 0,
    autoPopupShown: false,
    rewardsClaimed: false,
  };
}

export function resetDailyChallenge(state: MutableState, now: number): void {
  const day = getDailyChallengeDay(now);
  if (day === state.match2.dailyChallenge?.day) return;
  if (state.match2.dailyChallenge) clearDailyChallenge(state);
  startDailyChallenge(state, now);
}

export function progressDailyChallenge(
  state: MutableState,
  amount: number,
  goal: Match2DailyChallengeGoal,
): void {
  if (!state.match2.dailyChallenge) return;
  const challenge = getDailyChallenge(state.match2.dailyChallenge.day);
  if (!challenge || challenge.goal.type !== goal.type) return;
  const useSubType =
    challenge.goal.type === 'levelCompletes' ||
    challenge.goal.type === 'basicBlocks' ||
    challenge.goal.type === 'powerBlocks';
  if (useSubType && (challenge.goal as any).subType !== (goal as any).subType)
    return;
  state.match2.dailyChallenge.progress += amount;
}

export function clearDailyChallenge(state: MutableState): void {
  delete state.match2.dailyChallenge;
}

export function claimDailyChallengeRewards(
  state: MutableState,
  api: CurrencyReplicantAPI,
): void {
  if (!state.match2.dailyChallenge) return;
  if (!isDailyChallengeComplete(state)) return;
  const gems = getDailyChallengeRewardGems(state);
  if (!gems) return;
  Match2.modifiers.grantMatch2Rewards(
    state,
    [{ type: 'gems', amount: gems }],
    {
      feature: 'daily_challenge',
    },
    api,
  );
}
